import { render, staticRenderFns } from "./CampoCredibancoApps.vue?vue&type=template&id=53b11020&scoped=true"
import script from "./CampoCredibancoApps.vue?vue&type=script&lang=js"
export * from "./CampoCredibancoApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b11020",
  null
  
)

export default component.exports